<template lang='pug'>
  label.fpui-input-checkbox(:class='{checked:value, disabled:disabled}')
    input(type='checkbox', v-model='model', :disabled='disabled')
    span.fp-checkbox
      span.check(:class='color')
      span.content-checkbox
        slot
</template>

<script>

export default {
  props: {
    color: { type: String, default: 'blue' },
    value: { type: Boolean, required: true, default: false },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    model: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    }
  }
}
</script>

<style lang='less'>
@import "~@/shared/styles/_variables.less";

.fpui-input-checkbox {
  box-sizing: border-box;
  display: inline-block;
  margin-right: 20px;
  margin-bottom: 0;
  transform: translateZ(0);
  // Hide native checkbox
  .content-checkbox {
    margin-left: 5px;
  }
  input[type=checkbox] {
    opacity: 0;
    position: absolute;
    margin: 0;
    z-index: -1;
    width: 0;
    height: 0;
    overflow: hidden;
    left: 0;
    pointer-events: none;
  }
  label {
    cursor: pointer;
    padding-left: 0;
  }
  .fp-checkbox {
    position: relative;
    height: 30px;
    display: block;
    top: 8px;
    span  {
      display: inline-block;
      vertical-align: top;
      line-height: 24px;
    }
    &:before {
      position: absolute;
      left: 8px;
      top: 2px;
      content: "";
      background-color: rgba(0,0,0,0.5);
      height: 4px;
      width: 4px;
      border-radius: 100%;
      z-index: 1;
      opacity: 0;
      margin: 0;
    }

    .check {
      cursor: pointer;
      position: relative;
      display: inline-block;
      width: 20px;
      height: 20px;
      border: 2px solid;
      border-radius: 0;
      overflow: hidden;
      z-index: 1;
      color: darken(@grey, 70%);
      &.blue {
        color: @blue;
      }
      &.green {
        color: @green;
      }
      &.red {
        color: @red;
      }
      &.yellow {
        color: @yellow;
      }
    }
    .check:before {
      position: absolute;
      content: "";
      transform: rotate(45deg);
      display: block;
      margin-top: -4px;
      margin-left: 6px;
      width: 0;
      height: 0;
      animation: checkbox-off 0.3s forwards ease-out;
    }
  }

  input[type=checkbox]:focus + .fp-checkbox .check:after {
    opacity: 0.2;
  }
  input[type=checkbox]:checked + .fp-checkbox .check:before {
    box-shadow: 0 0 0 10px, 10px -10px 0 10px, 32px 0px 0 20px, 0px 32px 0 20px, -5px 5px 0 10px, 20px -12px 0 11px;
    animation: checkbox-on 0.3s forwards ease-out;
  }
  input[type=checkbox][disabled]:not(:checked) ~ .fp-checkbox .check:before, input[type=checkbox][disabled] + .circle {
    opacity: 0.5;
  }
  input[type=checkbox][disabled] + .fp-checkbox .check:after {
    background-color: rgba(0,0,0,0.84);
    transform: rotate(-45deg);
  }
  &.disabled {
    .fp-checkbox {
      .check {
        cursor: not-allowed;
        color: grey;
      }
    }
  }
}
</style>